export const toastGetters = {
    toasts: state => state.toasts,
};
